module.exports = __webpack_public_path__ + "static/media/image1.ecbd9e57.png";